import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';
import { batchMessagesInfiniteQueryOptions } from './use-get-batch-messages';

export default function useDeleteBatchMessages() {
  const { t } = useTranslation();
  return useMutation<RespondedType, ResponseError, number[]>({
    mutationKey: ['/DeleteBatchMessages'],
    mutationFn: (params) => fetcher('/DeleteBatchMessages', { BatchMessageIds: params }, { validResponseCodes: [0] }),
    onSuccess: () => Promise.allSettled([queryClient.invalidateQueries(batchMessagesInfiniteQueryOptions)]),
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data ? t('common.delete-success') : error?.message,
      }),
  });
}
